import * as React from 'react';
import { TUI_LIGHT } from '../values/style-values';

interface TFFSelectInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  required?: boolean;
  children: React.ReactNode;
  extraStyle?: React.CSSProperties;
  labelColor?: string;
}

export const TFFSelectInput: React.FC<TFFSelectInputProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  children,
  extraStyle,
  labelColor,
}) => {
  return (
    <label htmlFor={id} className={`input input-select${disabled ? ' disabled' : ''}`} style={extraStyle}>
      <span className="label" style={labelColor ? { color: `var(--${labelColor})` } : undefined}>{label}</span>
      <span className="group">
        <select id={id} value={value} onChange={onChange} disabled={disabled} required={required}>
          {children}
        </select>
        <span className="icon-control">
          <span
            className="icon medium chevron-down"
            data-theme={TUI_LIGHT}
            style={{ color: 'var(--color-functional-neutral-900)' }}
          ></span>
        </span>
      </span>
    </label>
  );
};

export default TFFSelectInput;
